export type TipTypeEnum = 'TIP' | 'NOTICE' | 'ERROR';
export const TipTypeEnum = {
  TIP: 'TIP' as TipTypeEnum,
  NOTICE: 'NOTICE' as TipTypeEnum,
  ERROR: 'ERROR' as TipTypeEnum,
};
